module.exports = __webpack_public_path__ + "img/triangle-15.69d4b37f.gif";